import { Affix, Popover } from '@mantine/core';
import { useState } from 'react';

import { ControllerPopoverTarget } from './ControllerPopoverTarget';
import { PopoverControllerDropdown } from './PopoverControllerDropdown';

export const PopoverController = () => {
  const [opened, setOpened] = useState<boolean>(false);

  const switchOpenedState = () => setOpened((previousState: boolean) => !previousState);

  return (
    <Affix position={{ right: 10, bottom: 10 }}>
      <Popover
        opened={opened}
        onChange={setOpened}
        position="top"
        withArrow
        arrowSize={10}
        offset={10}
        shadow="lg"
        floatingStrategy="fixed"
      >
        <ControllerPopoverTarget switchOpenedState={switchOpenedState} />
        <PopoverControllerDropdown switchOpenedState={switchOpenedState} />
      </Popover>
    </Affix>
  );
};
